document.addEventListener("DOMContentLoaded",function(){
  document.querySelectorAll(".nice-mk1-feedback").forEach(function(section){
    if(section.dataset.ready==="1") return;
    section.dataset.ready="1";

    var form=section.querySelector(".nice-mk1-feedback__form");
    var button=section.querySelector(".nice-mk1-feedback__submit");
    var error=section.querySelector(".nice-mk1-feedback__error");
    var success=section.querySelector(".nice-mk1-feedback__success");
    var endpoint=section.dataset.endpoint||"";

    form.addEventListener("submit",async function(event){
      event.preventDefault();
      error.hidden=true;

      if(!form.reportValidity()) return;

      button.disabled=true;

      var data=Object.fromEntries(new FormData(form).entries());
      var keys=[
        "eventExperience","musicDj","barDrinks","venueAtmosphere",
        "crowdCommunity","brandingVisuals","merch",
        "invitationPaymentCommunication"
      ];
      var ratings=keys.map(function(k){return Number(data[k]);}).filter(Boolean);

      data.averageScore=ratings.length
        ? (ratings.reduce(function(a,b){return a+b;},0)/ratings.length).toFixed(2)
        : "";
      data.eventCode="MK1";
      data.submittedAt=new Date().toISOString();
      data.page=window.location.href;

      try{
        if(!endpoint) throw new Error("endpoint_missing");

        await fetch(endpoint,{
          method:"POST",
          mode:"no-cors",
          headers:{"Content-Type":"text/plain;charset=utf-8"},
          body:JSON.stringify(data)
        });

        Array.from(form.children).forEach(function(el){
          if(el!==success) el.hidden=true;
        });
        success.hidden=false;
        success.scrollIntoView({behavior:"smooth",block:"center"});
      }catch(err){
        error.textContent=section.dataset.error;
        error.hidden=false;
        button.disabled=false;
      }
    });
  });
});